// src/app/components/user-behaviour/new-tips-dialog/new-tips-dialog.component.ts
import { Component, Inject, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

import { TipService } from '../../../services/tip.service';
import { SpinnerService } from '../../spinner-component/spinner.service';

export interface TipDialogData {
  tip?: any;
}

@Component({
  selector: 'app-new-tips-dialog',
  templateUrl: './new-tips-dialog.component.html',
  styleUrls: ['./new-tips-dialog.component.css']
,
  standalone: false
})
export class NewTipsDialogComponent implements OnInit {
  tipForm!: FormGroup;
  selectedFile: File | null = null;
  isEdit = false;
  imageUrl: string | null = null;

  constructor(
    private fb: FormBuilder,
    private tipService: TipService,
    private dialogRef: MatDialogRef<NewTipsDialogComponent>,
    private snackBar: MatSnackBar,                   // ← inject
    @Inject(MAT_DIALOG_DATA) public data: TipDialogData,
    private spinner: SpinnerService
  ) { }

  ngOnInit(): void {
    this.isEdit = !!this.data.tip;
    this.imageUrl = this.data?.tip?.image;
    console.log("this.data", this.data)
    this.tipForm = this.fb.group({
      source: [this.data.tip?.source ?? '', Validators.required],
      version: [this.data.tip?.version ?? '', Validators.required],
      heading: [this.data.tip?.heading ?? '', Validators.required],
      short_desc: [this.data.tip?.short_desc ?? '', Validators.required],
      long_desc: [this.data.tip?.long_desc ?? '', Validators.required],
    });
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.selectedFile = input.files?.[0] ?? null;
  }

  onSubmit(): void {
    if (this.tipForm.invalid) return;

    if (this.isEdit) {
      this.spinner.activate()
      this.tipService.updateTip(this.data.tip.id, this.tipForm.value)
        .subscribe({
          next: (response) => {
            if (response) {
              this.spinner.deactivate()
              this.snackBar.open('Tip updated successfully', 'Close', { duration: 5000 });
              this.dialogRef.close(true);
            }
          },
          error: () => {
            this.spinner.deactivate()
            this.snackBar.open('Failed to update tip', 'Close', { duration: 5000 });
          }
        });
      return;
    } else {
      if (!this.selectedFile) {
        this.snackBar.open('Please select an image before submitting', 'Close', { duration: 5000 });
        return;
      }

      const formData = new FormData();
      formData.append('file', this.selectedFile);
      formData.append('tips', JSON.stringify(this.tipForm.value));
      this.spinner.activate()
      this.tipService.uploadTipsImage(formData, 'web')
        .subscribe({
          next: (responseText: string) => {
              this.spinner.deactivate()
              this.snackBar.open('Tip created successfully', 'Close', { duration: 5000 });
              this.dialogRef.close(true);
          },
          error: (error) => {
            this.spinner.deactivate()
            this.snackBar.open('Failed to create tip', 'Close', { duration: 5000 });
          }
        });

    }
  }

  onDelete(): void {
    if (!this.data.tip?.id || !confirm('Are you sure you want to delete this tip?'))
      return;

    this.tipService.deleteTip(this.data.tip.id)
      .subscribe({
        next: () => {
          this.snackBar.open('Tip deleted', 'Close', { duration: 3000 });
          this.dialogRef.close(true);
        },
        error: () => {
          this.snackBar.open('Failed to delete tip', 'Close', { duration: 3000 });
        }
      });
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
